// extracted by mini-css-extract-plugin
export var button = "exercise-card-module--button--7e1b2";
export var card = "exercise-card-module--card--68972";
export var iconWrapper = "exercise-card-module--icon-wrapper--c0d16";
export var img = "exercise-card-module--img--f2878";
export var imgWrapper = "exercise-card-module--img-wrapper--ba6ff";
export var locked = "exercise-card-module--locked--050a3";
export var metadata = "exercise-card-module--metadata--e0bc5";
export var ratioClass = "exercise-card-module--ratio-class--ef885";
export var title = "exercise-card-module--title--80f97";